import { render } from "./ContactUsOverview.vue?vue&type=template&id=ea30ce94&ts=true"
import script from "./ContactUsOverview.vue?vue&type=script&lang=ts"
export * from "./ContactUsOverview.vue?vue&type=script&lang=ts"

import "./ContactUsOverview.vue?vue&type=style&index=0&id=ea30ce94&lang=scss"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__